import CommonAction from '../../shared/Http/Http';
import {BILLING_INFO_GET, BILLING_INFO_EDIT} from '../constants';

export const getBillingInfo = (globalType,provider) => CommonAction('GET', null, `backoffice-extended/settings/get/?globalType=${globalType}&provider=${provider}`, BILLING_INFO_GET, null);
export const editBillingInfo = (body) => CommonAction('PUT', null, `backoffice-extended/settings/edit`, BILLING_INFO_EDIT, body);